import script from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardHeader.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardHeader.vue?vue&type=style&index=0&id=32c5686c&lang=scss&scoped=true"
import "./DashboardHeader.vue?vue&type=style&index=1&id=32c5686c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c5686c"]])

export default __exports__